(ns common.db.effects.util
  (:require [re-frame.core :as rf]))

(defn invoke-callback
  "Invokes a callback, where the callback 'target' can be in multiple formats:
   - a function which we just apply on `args`,
   - `[target-fn & target-args]` which describes a printable partial function,
   - `[target-keyword & target-args]` which describes a printable partial re-frame event.
   The invocation parameters are appended after the target's arguments."
  [target & args]
  (when (some? target)
    (cond
      (fn? target)
      (apply target args)

      (vector? target) ; No support for other collections by design
      (let [[first-element & event-args] target]
        (cond
          (fn? first-element)
          (apply first-element (concat event-args args))

          (keyword? first-element)
          (rf/dispatch (into [first-element] (concat event-args args)))

          :else
          (assert false "Target's first element should be a function or a keyword.")))

      :else
      (assert false "Target should be a function or a vector."))))
